<div class="relative" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <!--  Prevent browser autocomplete by setting autocomplete attribute a non-standard value, as some browsers ignore "off" -->
  <input
    class="pr-10"
    type="text"
    autocomplete="force-off"
    aria-autocomplete="off"
    [attr.maxlength]="maxLength ?? null"
    cslInput
    role="combobox"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    [attr.aria-controls]="isOpen ? listboxId : null"
    [attr.aria-activedescendant]="activeDescendantId"
    [attr.aria-label]="ariaLabel || null"
    [attr.aria-labelledby]="ariaLabelledby || null"
    [id]="id"
    [formControl]="inputControl"
    [placeholder]="placeholder || ''"
    [cslInputPattern]="inputPattern || ''"
    [attr.aria-invalid]="ariaInvalid"
    [attr.aria-describedby]="ariaDescribedby"
    (keydown)="handleInput($event)"
  />
  @if (isLoading) {
    <csl-icon [name]="'loading-icon'" class="absolute right-0 top-0 mr-3 mt-3 block h-6 w-6 animate-spin" />
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayWidth]="trigger.elementRef.nativeElement.getBoundingClientRect().width"
  (overlayOutsideClick)="close()"
  (detach)="onDropdownClose()"
  [cdkConnectedOverlayPositions]="[
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top',
    },
  ]"
>
  <div
    class="g-dropdown-box-shadow g-dropdown-scrollbar -mx-px mt-1 max-h-80 grow rounded-xl bg-white"
    role="listbox"
    [id]="listboxId"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
